<template>
  <v-layout column>
    <!-- flexbox + set dimensions for small screens-->
    <v-row class='mt-10' xs6 offset-xs3>
      <v-col></v-col>
      <v-col>
        <!-- white panel with drop shadow -->
        <div class = "white elevation-2">
          <div class="pl-4 pr-4 pt-2 pb-2">
            <v-text-field
              type="email"
              name="email"
              v-model="email"
              placeholder="email" />

            <v-text-field
              type="password"
              name="password"
              v-model="password"
              placeholder="password" />

            <!-- v-html security warning -->
            <v-btn class="cyan"
              @click="register">Register
            </v-btn>
            <br>
            <div 
              class="error" 
              v-html="error" />
            <br>

            </div>
        </div>
      </v-col>
      <v-col></v-col>

    </v-row>
  </v-layout>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data () {
    return {
      email: '',
      password: '',
      error: null
    }
  },
  watch: {
    email () {
      console.log('email has changed value')
    }
  },
  methods: {
    async register() {
      try {
        const response = await AuthenticationService.register({
          email: this.email,
          password: this.password
        })
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
      } catch (error) {
        //what is returned from axios 
        this.error = error.response.data.error
      }
    }
  }
}
</script>

<style scoped>
.error {
  color: red;
}
</style>
